import { namedStateMapProvider } from "./namedState";
export const blurOnSearchState = namedStateMapProvider( 'blurOnSearch' );